import React from 'react';
import PipelinePage from './Pipeline';

/* The old Pipeline MB address. It is the one Pipeline, opened on the MB tab. */
const PipelineMB: React.FC = () => <PipelinePage start='mb' />;

export default PipelineMB;
